import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ExtensionRecommendations } from './extensionRecommendations.js';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IExtensionManagementServerService } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement.service';

const _moduleId = "vs/workbench/contrib/extensions/browser/webRecommendations";
let WebRecommendations = class WebRecommendations extends ExtensionRecommendations {
    get recommendations() { return this._recommendations; }
    constructor(productService, extensionManagementServerService) {
        super();
        this.productService = productService;
        this.extensionManagementServerService = extensionManagementServerService;
        this._recommendations = [];
    }
    async doActivate() {
        const isOnlyWeb = this.extensionManagementServerService.webExtensionManagementServer && !this.extensionManagementServerService.localExtensionManagementServer && !this.extensionManagementServerService.remoteExtensionManagementServer;
        if (isOnlyWeb && Array.isArray(this.productService.webExtensionTips)) {
            this._recommendations = ( (this.productService.webExtensionTips.map(extensionId => ({
                extension: extensionId.toLowerCase(),
                reason: {
                    reasonId: 6 ,
                    reasonText: ( localizeWithPath(
                        _moduleId,
                        0,
                        "This extension is recommended for {0} for the Web",
                        this.productService.nameLong
                    ))
                }
            }))));
        }
    }
};
WebRecommendations = ( (__decorate([
    ( (__param(0, IProductService))),
    ( (__param(1, IExtensionManagementServerService)))
], WebRecommendations)));

export { WebRecommendations };
